var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.description)?_c('div',{staticClass:"description",attrs:{"id":"descriptionText"},domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }